orders-planner-schedules-memo
  span { opts.value }
  script(type="typescript").
    this.mixin('orders.planner.schedules.memo');
